// src/pages/legal/PrivacyPolicy.tsx
import React from 'react';
import { DocsContent } from '../Docs/DocsContent';

const PrivacyPolicy = () => {
  const section = {
    title: 'Privacy Policy',
    path: '/legal/privacy-policy.md',
  };

  return (
    <div className="container py-4">
      <div className="row">
        <div className="col-12">
          <DocsContent section={section} />
        </div>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
